import { IPresentationMetadata } from "common/interfaces";
import moment from "moment";
import { createGlobalStyle } from "styled-components";

import { auth } from "js/firebase/auth";

export const LastActivityTooltipStyles = createGlobalStyle`
  .last-activity-tooltip.MuiTooltip-tooltip {
    font-size: 12px;
    font-weight: 400;
    padding: 8px;    
    color: black;
    max-width: 200px;
    line-height: 125%;
    border-radius: 4px;
    background: #FFF;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.20);
  }
`;

function capitalizeFirstOnly(s: string): string {
    if (!s) return s;
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

// Only EDITED is shown
const LAST_ACTIVITY_LABELS: Record<string, string> = {
    edited: "Edited"
};

export function getLastAccessedLabel(item: IPresentationMetadata, isGrid: boolean = false): { label: string; timeAgo: string; userName: string, actionLabel: string } | null {
    const { lastActivity } = item;

    if (!lastActivity?.createdAt) return null;

    const timeAgo = moment(lastActivity.createdAt).fromNow();
    const actionLabel = LAST_ACTIVITY_LABELS[lastActivity.activity] ?? lastActivity.activity;
    const userName = lastActivity.userId === auth().currentUser?.uid ? "you" : lastActivity.userName?.trim();

    const props = { timeAgo, userName, actionLabel };

    if (isGrid && lastActivity.userId !== auth().currentUser?.uid) {
        return { label: capitalizeFirstOnly(`${actionLabel} ${timeAgo}`), ...props };
    }

    const label = userName ? `${capitalizeFirstOnly(actionLabel)} by ${userName}, ${timeAgo}` : actionLabel;
    return { label, ...props };
}

